import React from 'react';
import {
  Moon, Heart, HeartPulse, Activity, Zap, Footprints, FlaskConical,
  ClipboardCheck, Target, TrendingUp, Settings, Home, Dna, Watch,
  CircleDot, Flame, Wind, MapPin, Scale, Sun, CheckCircle2, Cpu,
  Pencil, Upload, Folder, Brain, Bell, Users, Salad, Shield,
  ChevronDown,
} from 'lucide-react';

/* ─── shared props (unchanged from original API) ───────────────────── */
type IconProps = {
  size?: number;
  color?: string;
  className?: string;
};

const SW = 1.5; // global stroke-width — thin, crisp, elegant

/* ─── helper: wrap a Lucide component with our existing API ────────── */
function wrap(LucideIcon: React.FC<any>) {
  return function WrappedIcon({ size = 16, color = 'currentColor', className }: IconProps) {
    return <LucideIcon size={size} color={color} strokeWidth={SW} className={className} />;
  };
}

/* ─── exports (same names as before — zero consumer changes) ───────── */
export const IconMoon           = wrap(Moon);
export const IconHeart          = wrap(Heart);
export const IconHeartPulse     = wrap(HeartPulse);
export const IconActivity       = wrap(Activity);
export const IconShoe           = wrap(Footprints);
export const IconFlask          = wrap(FlaskConical);
export const IconClipboardCheck = wrap(ClipboardCheck);
export const IconTarget         = wrap(Target);
export const IconTrendUp        = wrap(TrendingUp);
export const IconSettings       = wrap(Settings);
export const IconHome           = wrap(Home);
export const IconDna            = wrap(Dna);
export const IconWatch          = wrap(Watch);
export const IconRing           = wrap(CircleDot);
export const IconFlame          = wrap(Flame);
export const IconLungs          = wrap(Wind);
export const IconMapPin         = wrap(MapPin);
export const IconScale          = wrap(Scale);
export const IconSun            = wrap(Sun);
export const IconCheckCircle    = wrap(CheckCircle2);
export const IconCpu            = wrap(Cpu);
export const IconEdit           = wrap(Pencil);
export const IconUpload         = wrap(Upload);
export const IconFolder         = wrap(Folder);
export const IconBrain          = wrap(Brain);
export const IconBell           = wrap(Bell);
export const IconUsers          = wrap(Users);
export const IconSalad          = wrap(Salad);
export const IconShield         = wrap(Shield);
export const IconChevronDown    = wrap(ChevronDown);

/* ─── IconZap: originally filled, keep same behavior ───────────────── */
export function IconZap({ size = 16, color = 'currentColor', className }: IconProps) {
  return <Zap size={size} color={color} strokeWidth={SW} fill={color} className={className} />;
}
